define("command-palette/services/command-palette/private/command-registry", ["exports", "@ember/service", "tracked-built-ins"], function (_exports, _service, _trackedBuiltIns) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"tracked-built-ins"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class CommandRegistryService extends _service.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "commands", new _trackedBuiltIns.TrackedObject({}));
    }
    register(commandId, command) {
      if (this.commands[commandId]) {
        throw new Error(`Unable to enable command "${commandId}" because it's already been enabled`);
      }
      this.commands[commandId] = command;
    }
    isRegistered(commandId) {
      return Boolean(this.commands[commandId]);
    }
  }
  _exports.default = CommandRegistryService;
});